import PropTypes from 'prop-types';
import { Icon, ECOMMERCE_PAYMENT_INSTALLATION } from '@bwoty-web/styleguide';
import LinkPush from './linkPush';
import './partialPayment.scss';

const PartialPayment = ({ labels }) => {
  return (
    <LinkPush
      href={labels?.partialPaymentLink?.href?.url}
      onClick={() =>
        window.dataLayer.push({
          event: 'partial_payment_link_click',
        })
      }
      target={labels?.partialPaymentLink?.href?.target || '_self'}
    >
      <Icon path={ECOMMERCE_PAYMENT_INSTALLATION} size="m" sizeMobile="m" />
      <span>{labels.partialPaymentLink?.title}</span>
    </LinkPush>
  );
};

PartialPayment.propTypes = {
  labels: PropTypes.shape({
    partialPaymentLink: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.shape({
        url: PropTypes.string,
        target: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default PartialPayment;
